export enum AssessmentStatus {
    SUBMITTED = "SUBMITTED",
    DRAFTED = "DRAFTED"
  }